import TablePagination from "@mui/material/TablePagination";
import type { useUrlPaging } from "../../hooks/useUrlState.ts";

interface UrlTablePaginationProps {
  total: number;
  paging: ReturnType<typeof useUrlPaging>;
}

/** Offset pagination for a table whose page and page size live in the URL. */
export default function UrlTablePagination({ total, paging }: UrlTablePaginationProps) {
  return (
    <TablePagination
      component="div"
      count={total}
      page={paging.page}
      onPageChange={(_, newPage) => paging.setPage(newPage)}
      rowsPerPage={paging.rowsPerPage}
      onRowsPerPageChange={(e) => paging.setRowsPerPage(parseInt(e.target.value, 10))}
      rowsPerPageOptions={[25, 50, 100]}
      sx={{ borderTop: 1, borderColor: "divider" }}
    />
  );
}
